<template>
  <v-container fluid v-resize="onResize">
    <v-icon
          small
          @click.stop="onOpenDialog"
          class="my-0 py-0"
      >
        mdi-calendar-account-outline
      </v-icon>
    <v-dialog
        v-model="dialog"
        :width="$vuetify.breakpoint.width"
    >
      <TimeTrackerHumanInfo
          :user-id="item.id"
          :user="item.user"
          :employee_number="item.employee_number"
          :modal-dialog="true"
      ></TimeTrackerHumanInfo>
    </v-dialog>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import TimeTrackerCalendarEvent from "@/components/TimeTracker/TimeTrackerCalendarEvent";
import Contract from "@/components/TimeTracker/Contract";
import ContractWeekExecution from "@/components/TimeTracker/ContractWeekExecution";
import CalendarDateUserStatistic from "@/components/TimeTracker/CalendarDateUserStatistic";
import ContractExecution from "@/components/TimeTracker/ContractExecution";
import Payed from "@/components/TimeTracker/Payed";
import TimeTrackerEventHoliday from "@/components/TimeTracker/TimeTrackerEventHoliday";
import TimeTrackerHumanInfo from "@/components/TimeTracker/TimeTrackerHumanInfo";

export default {
  name: 'TimeTrackerHumanInfoModal',
  props: {
    subtractHeight: {type: [Number], default: 80},
    height: {type: [Number], default: window.innerHeight},
    item: {default: null},
  },

  components: {
    TimeTrackerEventHoliday,
    TimeTrackerCalendarEvent,
    Contract,
    ContractWeekExecution,
    CalendarDateUserStatistic,
    ContractExecution,
    Payed,
    TimeTrackerHumanInfo,
  },

  computed: {
    // ...mapGetters('HumanUser', ['getColumns']),
    ...mapFields('HumanUser', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading']),
  },
  watch: {
    message_error(newValue, oldValue) {
      // console.log('watch loading', newValue, oldValue)
      if (newValue && this.pin_sending === true)
        this.dialog = false
    }
  },

  methods: {
    ...mapActions('HumanUser', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem']),

    onOpenDialog() {
      this.pin_sending = false
      this.pin_code = null
      this.dialog = true
      this.message_error = null
    },

    updateItem() {
      this.fetchItem(
          {
            itemId: this.item.human_user.id,
            dto_model: {to_consumer: 'HumanUserBaseDTO', from_consumer: 'HumanUserBaseDTO'},
            password: this.pin_code,
          })
      this.pin_code = null
    },

    onActivate() {
      //   // console.log('focus')
      //   self = this
      //   setTimeout(function() {
      //     self.dialog = false
      //     self.pin_code = null
      //     }, 30000);
    },

    actionWorkingEvent(event) {
      this.updateItem()
      this.pin_sending = true
    },

    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight};
    },

    updateOptions() {
      // console.log('updateOptions')
      this.fetchItemList({to_consumer: 'HumanUserBaseDTO', from_consumer: 'HumanUserBaseDTO'})
    },

    breadscrumbs() {
      return [
        {text: 'Home', href: '/site/',},
        {text: 'TimeTracker', href: '/site/time_tracker',},
        // {text: this.editedItemBom.name, href: '/sitete/bom/' + this.$route.params.itemId,},
      ]
    },
  },

  async mounted() {
    // console.log('mounted')
  },

  beforeDestroy() {
    // prevent memory leak
    clearInterval(this.interval)
  },

  data() {
    return {
      windowSize: {x: 0, y: 0,},
      dialog: false,
      pin_sending: false,
      pin_code: null,
    }
  }
}
</script>

<style scoped lang="scss">

</style>
